<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="blue">
        <h4 slot="title" class="title text-left">Reset Password</h4>
        <p slot="description" class="description">
          Please enter your new password<br />
          <em>(minimum 12 characters)</em>
        </p>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>key</md-icon>
          <label>New Password...</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>key</md-icon>
          <label>Confirm Password...</label>
          <md-input v-model="password_confirmation" type="password"></md-input>
        </md-field>
        <md-button
          type="submit"
          slot="footer"
          class="md-simple md-primary md-lg"
          @click.prevent="resetPassword"
        >
          Lets Go
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import authApi from "@/services/api/auth";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      password: null,
      password_confirmation: null
    };
  },
  methods: {
    resetPassword() {
      const user = {
        password: this.password,
        password_confirmation: this.password_confirmation,
        token: this.$route.query.token || null,
        email: this.$route.query.email || null
      };

      authApi.resetPassword(user).then(resp => {
        (this.password = null),
          (this.password_confirmation = null),
          this.$notify({
            timeout: 2500,
            message: "Your password has now been reset.",
            icon: "thumb_up",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "success"
          });

        setTimeout(() => {
          this.$router.push({ name: "Login" });
        }, 2500);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-login {
  .description {
    text-align: left;
    margin-bottom: 2rem;
  }
}
</style>
